'use strict'

import { ROOT } from './root'

export const TREE = ROOT
export { ROOT } from './root'
